import { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { HudHintType } from '~/shared';
import hospitalIcon from '../../assets/icons/hospital.svg';
import {
	StyledContainer,
	StyledDescription,
	StyledHeader,
	StyledTimerNumber,
	StyledTitle,
	StyledWrapper,
} from './Hint.styled';

const HINT_DURATION_MS = 5000;

const HINT_ICONS: Record<HudHintType, string> = {
	[HudHintType.Hospital]: hospitalIcon,
};

const Hint = () => {
	const hint = useObservable(rage.hud.getHint());
	const minimapInfo = useObservable(rage.gui.getMinimapInfo());
	const gameConfigs = useObservable(rage.gameConfig.getConfigs());
	const [timeLeft, setTimeLeft] = useState(0);

	useEffect(() => {
		if (!hint) {
			setTimeLeft(0);
			return;
		}

		const totalMs = hint.timer ?? HINT_DURATION_MS;
		setTimeLeft(Math.ceil(totalMs / 1000));

		const interval = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					clearInterval(interval);
					rage.hud.hideHint();
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [hint]);

	const content = hint ? gameConfigs.gameplay?.hudHints[hint.type] : null;
	const icon = hint ? HINT_ICONS[hint.type] : null;

	return (
		<StyledWrapper
			$x={minimapInfo.x}
			$bottom={minimapInfo.y + minimapInfo.height}
		>
			<CSSTransition
				in={!!content}
				timeout={300}
				classNames="hint"
				unmountOnExit
				appear
			>
				<StyledContainer>
					<StyledHeader>
						{icon && (
							<ImgIcon icon={icon} width={14} height={14} color="#ffffff" />
						)}
						<StyledTitle>{content?.title}</StyledTitle>
					</StyledHeader>
					<StyledDescription>{content?.description}</StyledDescription>
					<StyledTimerNumber>
						<Text>{timeLeft}</Text>
					</StyledTimerNumber>
				</StyledContainer>
			</CSSTransition>
		</StyledWrapper>
	);
};

export { Hint };
